import React from 'react';

function Footer() {
  return (
    <footer className="container">
      <p>&copy; 2025 Church Aware Inc.</p> <a href="/privacy">Privacy Policy</a>
    </footer>
  );
}

export default Footer;